import PropTypes from 'prop-types';
import React from 'react';

function Number(props) {
  const { fill } = props;
  return (
    <svg
      height="24"
      style={{ fill: 'none' }}
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5.125 8.87646H21.377" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
      <path d="M2.625 16.3774H18.877" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
      <path
        d="M12.0008 2.62598L5.75 21.3783"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M18.2518 2.62598L12.001 21.3783"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
    </svg>
  );
}

Number.propTypes = {
  fill: PropTypes.string.isRequired
};
export default Number;
